// icons
import { IconType } from "react-icons";
import { MdOutlineSettings, MdOutlineQuiz } from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import { TfiLayoutSliderAlt } from "react-icons/tfi";
import { TbUsers, TbSmartHome, TbCategory } from "react-icons/tb";
import { FaRegBell } from "react-icons/fa";
import { GoCreditCard } from "react-icons/go";
import { LiaCoinsSolid } from "react-icons/lia";
import { PERMISSIONS } from "../../data/permissions";
import { Permission } from "../../types/types";

interface Link {
  title: string;
  icon: IconType;
  path: string;
  permissions: {
    path: string;
    method: string;
    model: string;
    scope: string;
  }[];
  children?: Link[];
}

export const links: Link[] = [
  {
    title: "الرئيسية",
    icon: TbSmartHome,
    path: "/",
    permissions: [PERMISSIONS.GET_STATISTICS_PROCESSES_ADMIN],
  },
  {
    title: "المستخدمين",
    icon: TbUsers,
    path: "/users",
    permissions: [PERMISSIONS.POST_USERS],
    children: [
      {
        title: "الطلاب",
        icon: TbUsers,
        path: "/users?roles=3&role_key=students", // students
        permissions: [PERMISSIONS.POST_USERS],
      },
      {
        title: "مدخلي البيانات",
        icon: TbUsers,
        path: "/users?roles=5&role_key=data-entry", // data entry
        permissions: [PERMISSIONS.POST_USERS],
      },
    ],
  },
  {
    title: "التصنيفات",
    icon: TbCategory,
    path: "/categories?parent_key=item",
    permissions: [PERMISSIONS.GET_CATEGORIES_ADMIN],
    children: [
      {
        title: "تصنيفات الاسئلة الاكثر تكرارا",
        icon: TbCategory,
        path: "/categories?parent_key=faq",
        permissions: [PERMISSIONS.GET_CATEGORIES_ADMIN],
      },
      {
        title: "تصنيفات المواضيع",
        icon: TbCategory,
        path: "/categories?parent_key=subject",
        permissions: [PERMISSIONS.GET_CATEGORIES_ADMIN],
      },
      {
        title: "تصنيفات المصادر",
        icon: TbCategory,
        path: "/categories?parent_key=referral_source",
        permissions: [PERMISSIONS.GET_CATEGORIES_ADMIN],
      },
    ],
  },
  {
    title: "الامتحانات",
    icon: MdOutlineQuiz,
    path: "/exams",
    permissions: [PERMISSIONS.GET_EXAMS_ADMIN],
  },
  {
    title: "باقات النقاط",
    icon: LiaCoinsSolid,
    path: "/points-packages",
    permissions: [PERMISSIONS.GET_POINT_WALLETS_ADMIN],
  },
  {
    title: "بطاقات  مسبقة الدفع",
    icon: GoCreditCard,
    path: "/prepaid-cards",
    permissions: [PERMISSIONS.GET_PREPAID_CARDS],
  },
  {
    title: "متابعة الحركة المالية",
    icon: GrTransaction,
    path: "/transactions",
    permissions: [PERMISSIONS.GET_WALLETS_ADMIN],
  },
  {
    title: "مشتريات الامتحانات",
    icon: MdOutlineQuiz,
    path: "/user-exam-purchases",
    permissions: [PERMISSIONS.GET_USER_EXAM_PURCHASES_ADMIN],
  },
  {
    title: "ارسال اشعار",
    icon: FaRegBell,
    path: "/push-notifications",
    permissions: [PERMISSIONS.GET_FCM_NOTIFICATIONS],
  },
  {
    title: "البانرز",
    icon: TfiLayoutSliderAlt,
    path: "/banners",
    permissions: [PERMISSIONS.GET_BANNERS_ADMIN],
  },
  {
    title: "الضبط",
    icon: MdOutlineSettings,
    path: "/settings",
    permissions: [PERMISSIONS.GET_SETTINGS_ADMIN],
  },
];
